/** Client-side mirror of server approval rules (server still enforces on approve). */

export function getApprovalBlock(research, policy) {
  if (!policy?.enforcementEnabled) {
    return { blocked: false };
  }

  const check = research?.plagiarismCheck || {};
  const status = check.status || "pending";

  if (policy.requireCompletedCheck && status !== "completed") {
    const detail =
      status === "processing"
        ? "Plagiarism check is still processing. Wait for DrillBit results before approving."
        : status === "failed"
        ? "Plagiarism check failed. Re-run the check before approving."
        : "A completed DrillBit plagiarism check is required before approval.";
    return { blocked: true, code: "check_incomplete", message: detail };
  }

  if (
    policy.enforceSimilarityThreshold &&
    status === "completed" &&
    check.similarityPercent != null &&
    check.similarityPercent >= policy.maxSimilarityForApproval
  ) {
    return {
      blocked: true,
      code: "similarity_too_high",
      message: `Similarity is ${check.similarityPercent}% (maximum allowed for approval is below ${policy.maxSimilarityForApproval}%).`
    };
  }

  return { blocked: false };
}

export function isHighSimilarity(similarityPercent, threshold) {
  return similarityPercent != null && threshold != null && similarityPercent >= threshold;
}
